import React from 'react';
import { Link } from 'react-router-dom';
import StarRating from './StarRating';
import { useFavorites } from '../context/FavoritesContext';

export default function ProviderCard({ provider }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const fav = isFavorite(provider.id);

  return (
    <div className="provider-card">
      <div className="provider-card-image">
        <img src={provider.cover} alt={provider.name} loading="lazy" />
        {provider.featured && <span className="badge badge-featured">Destacado</span>}
        {provider.verified && <span className="badge badge-verified">✔ Verificado</span>}
        <button
          type="button"
          className={`favorite-btn ${fav ? 'active' : ''}`}
          onClick={() => toggleFavorite(provider.id)}
          aria-label={fav ? 'Quitar de favoritos' : 'Guardar en favoritos'}
        >
          {fav ? '♥' : '♡'}
        </button>
      </div>
      <div className="provider-card-body">
        <h3>{provider.name}</h3>
        <p className="provider-location">📍 {provider.city}, {provider.state}</p>
        <StarRating rating={provider.rating} reviews={provider.reviews} />
        <p className="provider-price">Desde <strong>${provider.priceFrom.toLocaleString('es-MX')} MXN</strong></p>
        <Link to={`/proveedor/${provider.id}`} className="btn btn-outline btn-block">
          Ver perfil
        </Link>
      </div>
    </div>
  );
}
